import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate, useLocation } from "react-router-dom";
import { FgpProvider } from "@/context/FgpContext";
import { Toaster } from "@/components/ui/sonner";
import { CookieConsent } from "@/components/CookieConsent";

import { AppShell } from "@/components/layout/AppShell";
import Landing from "@/pages/Landing";
import About from "@/pages/About";
import PrivacyPolicy from "@/pages/PrivacyPolicy";
import RefundPolicy from "@/pages/RefundPolicy";
import TermsConditions from "@/pages/TermsConditions";
import Security from "@/pages/Security";
import Login from "@/pages/Login";
import Register from "@/pages/Register";
import PortalLogin from "@/pages/PortalLogin";
import ResetPassword from "@/pages/ResetPassword";
import Setup from "@/pages/Setup";
import Dashboard from "@/pages/Dashboard";
import DailyBrief from "@/pages/DailyBrief";
import Tools from "@/pages/Tools";
import Travel from "@/pages/Travel";
import Expenses from "@/pages/Expenses";
import Budgeting from "@/pages/Budgeting";
import People from "@/pages/People";
import PersonDetail from "@/pages/PersonDetail";
import RelationshipView from "@/pages/RelationshipView";
import CalendarPage from "@/pages/CalendarPage";
import Tasks from "@/pages/Tasks";
import Notes from "@/pages/Notes";
import Contacts from "@/pages/Contacts";
import Documents from "@/pages/Documents";
import Renewals from "@/pages/Renewals";
import Alerts from "@/pages/Alerts";
import Reports from "@/pages/Reports";
import Settings from "@/pages/Settings";
import WorkspaceUsers from "@/pages/WorkspaceUsers";
import PlatformAdmin from "@/pages/PlatformAdmin";
import AuthCallback from "@/pages/AuthCallback";

function AppRoutes() {
  const location = useLocation();
  // Reactive check: re-renders when navigation clears the OAuth hash (fixes stuck "Signing you in…").
  const isOAuthReturn = (location.hash || "").includes("session_id=");
  if (isOAuthReturn) return <AuthCallback />;
  return (
    <Routes>
      <Route path="/" element={<Landing />} />
      <Route path="/about" element={<About />} />
      <Route path="/privacy" element={<PrivacyPolicy />} />
      <Route path="/refunds" element={<RefundPolicy />} />
      <Route path="/terms" element={<TermsConditions />} />
      <Route path="/security" element={<Security />} />
      <Route path="/login" element={<Login />} />
      <Route path="/register" element={<Register />} />
      <Route path="/portal" element={<PortalLogin />} />
      <Route path="/reset-password" element={<ResetPassword />} />
      <Route path="/setup" element={<Setup />} />

      <Route path="/app" element={<AppShell />}>
        <Route index element={<Navigate to="/app/dashboard" replace />} />
        <Route path="dashboard" element={<Dashboard />} />
        <Route path="brief" element={<DailyBrief />} />
        <Route path="people" element={<People />} />
        <Route path="people/:id" element={<PersonDetail />} />
        <Route path="relationships" element={<RelationshipView />} />
        <Route path="calendar" element={<CalendarPage />} />
        <Route path="tasks" element={<Tasks />} />
        <Route path="notes" element={<Notes />} />
        <Route path="tools" element={<Tools />} />
        <Route path="budgeting" element={<Budgeting />} />
        <Route path="contacts" element={<Contacts />} />
        <Route path="documents" element={<Documents />} />
        <Route path="renewals" element={<Renewals />} />
        <Route path="travel" element={<Travel />} />
        <Route path="expenses" element={<Expenses />} />
        <Route path="alerts" element={<Alerts />} />
        <Route path="reports" element={<Reports />} />
        <Route path="settings" element={<Settings />} />
        <Route path="users" element={<WorkspaceUsers />} />
        <Route path="admin" element={<PlatformAdmin />} />
      </Route>

      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}

function App() {
  return (
    <FgpProvider>
      <BrowserRouter>
        <AppRoutes />
        <CookieConsent />
      </BrowserRouter>
      <Toaster position="top-right" richColors />
    </FgpProvider>
  );
}

export default App;
